var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.report.title)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.report.title))]),_c('v-container',{staticClass:"main-section-reports-detail ma-1 pa-1",attrs:{"fluid":""}},[_c('ReportsDetail',{attrs:{"report":_vm.report}})],1)],1):_c('div',[_c('p',[_vm._v("Loading or report not found...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }